import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ALL_SERVICES = [
  { icon: '⚖️', title: 'Tư vấn pháp lý', desc: 'Hợp đồng, giấy phép, tranh chấp pháp lý ngành F&B', color: '#fed7aa', textColor: '#ea580c', to: '/dich-vu/tu-van-phap-ly' },
  { icon: '🛡️', title: 'Dịch vụ hỗ trợ ATFP', desc: 'An toàn thực phẩm, chứng nhận ISO 22000', color: '#dcfce7', textColor: '#16a34a', to: '/dich-vu/atfp' },
  { icon: '🧮', title: 'Hỗ trợ kế toán', desc: 'Kế toán chuyên biệt, báo cáo tài chính F&B', color: '#cffafe', textColor: '#0891b2', to: '/dich-vu/ke-toan' },
  { icon: '📦', title: 'Đặt hàng nguyên liệu', desc: 'B2B kết nối nhà cung cấp nguyên liệu uy tín', color: '#dbeafe', textColor: '#2563eb', to: '/dich-vu/nguyen-lieu' },
  { icon: '👥', title: 'Danh sách hội viên', desc: 'Giới thiệu các doanh nghiệp thành viên của Hiệp hội F&B', color: '#fef3c7', textColor: '#d97706', to: '/dich-vu/hoi-vien' },
  { icon: '📊', title: 'Khảo sát chuỗi F&B', desc: 'Thống kê số liệu về chuỗi, cửa hàng, doanh thu', color: '#ede9fe', textColor: '#7c3aed', to: '/dich-vu/khao-sat-chuoi' },
  { icon: '📋', title: 'Thủ tục đăng ký hội viên', desc: 'Hướng dẫn quyền lợi và quy trình tham gia hội viên', color: '#fce7f3', textColor: '#db2777', to: '/dich-vu/dang-ky-hoi-vien' },
  { icon: '🏪', title: 'Khảo sát cửa hàng tiện lợi', desc: 'Lịch cập nhật dữ liệu tiếp theo: Thứ Sáu, 21/03', color: '#f0fdf4', textColor: '#15803d', to: '/dich-vu/khao-sat-cua-hang' },
  { icon: '📁', title: 'Tài liệu & Báo cáo ngành', desc: 'Đăng ký nhận tài liệu, gửi yêu cầu qua email', color: '#fef2f2', textColor: '#dc2626', to: '/dich-vu/tai-lieu' },
  { icon: '📞', title: 'Trung tâm hỗ trợ F&B', desc: 'Tổng đài tư vấn toàn diện kinh doanh F&B, nhượng quyền', color: '#f5f3ff', textColor: '#6d28d9', to: '/dich-vu/ho-tro' },
];

export default function CacDichVuKhacPage() {
  return (
    <div className="max-w-5xl mx-auto space-y-8 animate-fade-in">
      <div className="rounded-2xl p-8 md:p-12" style={{ background: 'linear-gradient(135deg, #374151 0%, #4b5563 50%, #6b7280 100%)' }}>
        <h1 className="font-display font-black text-3xl text-white mb-2">Tất cả dịch vụ</h1>
        <p className="text-gray-300">Khám phá đầy đủ các dịch vụ hỗ trợ doanh nghiệp F&B của FNB HUB</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ALL_SERVICES.map(s => (
          <Link key={s.title} to={s.to}
            className="fnb-card p-5 flex items-start gap-4 group">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl shrink-0 group-hover:scale-110 transition-transform"
                 style={{ background: s.color }}>
              {s.icon}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm mb-1 group-hover:opacity-80 transition-colors"
                 style={{ color: 'var(--text-1)' }}>{s.title}</p>
              <p className="text-xs leading-relaxed" style={{ color: 'var(--text-3)' }}>{s.desc}</p>
            </div>
            <ArrowRight size={14} className="shrink-0 mt-0.5 opacity-30 group-hover:opacity-100 transition-opacity"
                        style={{ color: s.textColor }} />
          </Link>
        ))}
      </div>
    </div>
  );
}
